import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, timeout: 25000 });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sat_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("sat_token", t);
  else localStorage.removeItem("sat_token");
};
